module.exports = __webpack_public_path__ + "img/homemain.83304ce3.png";